import React from "react";

const JQuery_Syntax = () => {
  return (
    <div>
      <h1>JQuery_Syntax</h1>
      <p>Placeholder component for: "JQuery_Syntax"</p>
    </div>
  );
};

export default JQuery_Syntax;
